import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 0 1rem 1rem;

  .my-task {
    display: block;
    color: #000;
    padding: 0.5rem 0;
    transition: background 0.2s ease-in-out;

    :hover,
    &.selected {
      background: ${({ theme }) => theme.green_light};
    }
  }
`

export const StickyWrapper = styled.div`
  position: sticky;
  top: 0;
  padding-top: 1rem;
`
